import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil, RounderUtil } from 'utils'

import { SustraccionVentaSelect } from 'sharedComponents/select'

const TipoFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  values,
  index,
  handleChange,
  setValues,
  actualizarFilaHandler,
  montoBase
}) => {
  const tiposRef = React.useRef(null)

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(`input-sustraccion-monto-${index}`, e)
    },
    [index]
  )

  const onInputChange = React.useCallback(
    e => {
      handleChange(e)
      const nuevoTipoSustraccion = e.target.value
      values._idSustraccionVenta = nuevoTipoSustraccion

      if (!nuevoTipoSustraccion) {
        actualizarFilaHandler({ index: index, rowData: { ...values, monto: 0, porcentaje: 0 } })
        return
      }

      const matchTipo = tiposRef.current.find(x => x._id === nuevoTipoSustraccion)
      values.porcentaje = matchTipo.porcentaje

      const monto = RounderUtil.round((montoBase * matchTipo.porcentaje) / 100, 2)
      values.monto = monto

      actualizarFilaHandler({ index: index, rowData: values })

      setValues(values)
    },
    [handleChange, values, setValues, actualizarFilaHandler, index, montoBase]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='_idSustraccionVenta'>
          {({ field }) => (
            <SustraccionVentaSelect
              {...field}
              tiposRef={tiposRef}
              id={`select-sustraccion-tipo-${index}`}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onChange={onInputChange}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoFormGroup)
